export enum FilterDataType {
    text = 'text',
    array = 'array',
    dateEqual = 'dateEqual',
    date = 'date',
    dateRange = 'dateRange'
}
